// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.referral-page-outer {
  background-color: #181a20;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 90px 0px 30px;
  color: #ffffff;
  overflow: hidden;
  position: relative;
  flex-direction: column;
}

.referral-container {
  padding: 0px 0px 110px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  z-index: 2;
  position: relative;
}

.referral-hero-left {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.referral-badge {
  background: #ffffff12;
  color: #D1AA67;
  padding: 6px 16px;
  border-radius: 100px;
  font-size: 15px;
  font-weight: 600;
  margin-bottom: 24px;
}

.referral-title {
  font-size: 60px;
  font-weight: 800;
  line-height: 1.15;
  color: #ffffff;
  margin: 0 0 20px 0;
  letter-spacing: -0.02em;
}

.gold-text {
  color: #D1AA67;
}

.referral-subtitle {
  font-size: 23px;
  color: #84888C;
  line-height: 1.4;
  margin-bottom: 36px;
  max-width: 480px;
  padding-top: 8px;
}

.gold-text-accent {
  color: #D1AA67;
  font-weight: 700;
  font-size: 30px;
}

.referral-actions {
  display: flex;
  align-items: center;
  gap: 24px;
}

.invite-btn {
  background: #D1AA67;
  color: #ffffff;
  border: none;
  padding: 18px 36px;
  border-radius: 100px;
  font-size: 20px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: transform 0.2s ease, box-shadow 0.2s ease, opacity 0.2s ease;
}

.invite-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 24px rgba(212, 175, 55, 0.3);
}


.how-it-works-btn {
  background: transparent;
  border: none;
  color: #84888C;
  font-size: 20px;
  font-weight: 600;
  cursor: pointer;
  padding: 8px 16px;
  transition: color 0.2s ease;
}

.how-it-works-btn:hover {
  color: #ffffff;
}

/* Center Column - Chest Image */
.referral-hero-center {
  max-width: 600px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.chest-image {
  width: 100%;
  height: auto;
  object-fit: contain;
  filter: drop-shadow(0 0 30px rgba(34, 197, 94, 0.15));
  animation: float 4s ease-in-out infinite;
}

@keyframes float {
  0% {
    transform: translateY(0px);
  }

  50% {
    transform: translateY(-10px);
  }

  100% {
    transform: translateY(0px);
  }
}

/* Right Column - User Stats Card */
.referral-hero-right {
  width: 100%;
  display: flex;
  justify-content: flex-end;
}

.referral-card {
  background: linear-gradient(180deg, rgb(255 255 255 / 9%) 0%, rgb(255 255 255 / 5%) 15%);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 32px;
  padding: 24px 16px;
  width: 100%;
  max-width: 480px;
}

.card-top {
  display: flex;
  flex-direction: column;
  padding-bottom: 0px;
  margin-bottom: 20px;
}

.card-label {
  color: rgba(255, 255, 255, 0.4);
  font-size: 12px;
  font-weight: 600;
}

.code-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.code-value {
  font-size: 30px;
  font-weight: 600;
  color: #ffffff;
}

.stats-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  margin-bottom: 28px;
}

.stat-item {
  background: rgba(255, 255, 255, 0.02);
  border: 1px solid rgba(255, 255, 255, 0.04);
  border-radius: 16px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  transition: border-color 0.2s ease, background 0.2s ease;
}

.stat-label {
  color: rgba(255, 255, 255, 0.4);
  font-size: 12px;
  font-weight: 500;
  line-height: 1.3;
}

body .stat-val {
  font-size: 24px;
  font-weight: 700;
  color: #fff;
}

span.stat-val.text-gold {
  color: #D1AA67;
}

.text-white {
  color: #ffffff;
}

.share-link-section {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.share-label {
  color: rgba(255, 255, 255, 0.4);
  font-size: 12px;
  font-weight: 500;
}

.share-input-wrap {
  display: flex;
  align-items: center;
  background: #ffffff0f;
  border-radius: 5px;
  padding: 6px 6px 6px 16px;
  transition: border-color 0.2s ease;
}

.share-input-wrap:focus-within {
  border-color: rgba(212, 175, 55, 0.4);
}

.share-input {
  background: transparent;
  border: none;
  color: rgba(255 255 255);
  flex: 1 1;
  font-size: 0.85rem;
  font-family: inherit;
  outline: none;
  min-width: 0;
  padding-right: 8px;
}

.share-copy-btn {
  background: none;
  border: none;
  color: rgba(255, 255, 255, 0.6);
  width: 36px;
  height: 33px;
  border-radius: 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
}

/* Ticker Styling */
.ticker-wrap {
  overflow: hidden;
  background-color: #000000;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  padding: 20px 0;
  width: 100%;
}

.ticker-track {
  display: flex;
  width: max-content;
  animation: marquee-ticker 130s linear infinite;
}

.ticker-group {
  display: flex;
  align-items: center;
  flex-shrink: 0;
}

.ticker-item {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 0 32px;
}

.ticker-pair {
  color: #84888C;
  font-size: 18px;
  font-weight: 600;
}

.ticker-price {
  color: #ffffff;
  font-size: 22px;
  font-weight: 700;
}

.ticker-change {
  color: #4ADE80;
  font-size: 18px;
  font-weight: 500;
}

.ticker-chart {
  height: 18px;
  width: auto;
}

.ticker-divider {
  color: rgba(255, 255, 255, 0.15);
  font-size: 18px;
  margin-left: 16px;
}

@keyframes marquee-ticker {
  0% {
    transform: translateX(0);
  }

  100% {
    transform: translateX(-50%);
  }
}

.referral-overview-section {
  width: 100%;
  padding: 110px 0px 0px;
  display: flex;
  flex-direction: column;
  background-color: #181a20;
  gap: 24px;
}

.overview-section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 32px;
}

.overview-section-title {
  font-size: 40px;
  font-weight: 600;
  color: #ffffff;
  margin: 0;
}

.time-select-dropdown-container {
  position: relative;
  z-index: 50;
}

.time-select-dropdown {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  background: #ffffff0f;
  border: 1px solid #ffffff0d;
  border-radius: 7px;
  padding: 7px 18px;
  color: #84888C;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  min-width: 150px;
  transition: all 0.2s ease;
}

.time-select-menu {
  position: absolute;
  top: calc(100% + 6px);
  right: 0;
  background: #24262b;
  border: 1px solid #323232;
  border-radius: 12px;
  padding: 6px;
  width: 170px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.5);
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.time-select-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;
  color: rgba(255, 255, 255, 0.6);
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  border-radius: 8px;
  transition: all 0.2s ease;
}

.time-select-item:hover {
  background: rgba(255, 255, 255, 0.03);
  color: #ffffff;
}

.time-select-item.selected {
  color: #ffffff;
}

.check-icon-circle {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #D1AA67;
  color: #000000;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  font-weight: bold;
}

/* Stats Row Grid */
.overview-stats-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 24px;
  margin-bottom: 42px;
}

.overview-stat-card {
  width: 100%;
  background: #ffffff0d;
  border: 1px solid #ffffff0f;
  border-radius: 16px;
  padding: 20px;
  display: flex;
  align-items: center;
  gap: 16px;
  transition: border-color 0.2s ease;
}

.overview-stat-card:hover {
  border-color: rgba(255, 255, 255, 0.1);
}

.stat-card-icon-wrap {
  width: 56px;
  height: 56px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
}

.icon-green {
  background: #091E19;
  color: #10B981;
}

body.light_theme .icon-green {
  background: #091e1912;
}

body.light_theme .icon-orange {
  background: #2c140c12;
}

body.light_theme .icon-blue {
  background: #10183012;
}

body.light_theme .icon-purple {
  background: #210f2f12;
}

.icon-orange {
  background: #2C140C;
  color: #F97316;
}

.icon-blue {
  background: #101830;
  color: #3B82F6;
}

.icon-purple {
  background: #210F2F;
  color: #A855F7;
}

.stat-card-details {
  display: flex;
  flex-direction: column;
}

.stat-card-label {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.4);
  font-weight: 500;
  margin-bottom: 0px;
}

.stat-card-val {
  font-size: 20px;
  font-weight: 700;
  color: #ffffff;
}

.stat-card-sub {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.3);
}

/* Sidebar + Content Panel Layout */
.overview-content-layout {
  display: grid;
  grid-template-columns: 280px 1fr;
  gap: 24px;
  margin-bottom: 40px;
}

.overview-tab-sidebar {
  border-radius: 24px;
  padding: 10px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  height: -moz-fit-content;
  height: 100%;
  background: #ffffff0d;
  border: 1px solid #ffffff0a;
}

.tab-sidebar-btn {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 20px 20px;
  border-radius: 14px;
  border: none;
  background: transparent;
  color: rgba(255, 255, 255, 0.5);
  font-size: 18px;
  font-weight: 500;
  cursor: pointer;
  text-align: left;
  transition: all 0.2s ease;
}

.tab-sidebar-btn img,
.tab-sidebar-btn i {
  opacity: 0.6;
  font-size: 22px;
  line-height: 1;
  flex-shrink: 0;
}

.tab-sidebar-btn:hover {
  color: #ffffff;
  background: rgba(255, 255, 255, 0.02);
}

.tab-sidebar-btn.active {
  background: #b3883f;
  color: #ffffff;
}

.tab-sidebar-btn.active img,
.tab-sidebar-btn.active i {
  opacity: 1;
}

.tab-sidebar-btn:disabled,
.tab-sidebar-btn[aria-disabled="true"] {
  opacity: 0.4;
  cursor: not-allowed;
  background: transparent;
  color: rgba(255, 255, 255, 0.75);
}

.tab-sidebar-btn:disabled:hover,
.tab-sidebar-btn[aria-disabled="true"]:hover {
  background: transparent;
  color: rgba(255, 255, 255, 0.35);
}

/* Tab Content Panel Styling */
.overview-tab-content-panel {
  background: #ffffff0d;
  border: 1px solid #ffffff0a;
  border-radius: 24px;
  padding: 40px;
  min-height: 400px;
}

.commission-performance-wrap {
  display: flex;
  flex-direction: column;
  gap: 36px;
}

.panel-inner-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 0px;
}

.panel-inner-title {
  width: 100%;
  font-size: 24px;
  font-weight: 700;
  margin: 0;
}

.overview-content-layout .panel-empty-state-wrap .empty-state-img {
  filter: contrast(0);
  opacity: 1;
}

.date-range-container {
  position: relative;
  z-index: 40;
}

.date-range-badge {
  display: flex;
  align-items: center;
  gap: 8px;
  white-space: nowrap;
  background: rgba(255, 255, 255, 0.02);
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 8px;
  padding: 6px 12px;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.5);
  cursor: pointer;
  transition: all 0.2s ease;
}

.date-range-badge i {
  color: #ffffff;
  /* Make toggle calendar icon white */
}

.date-range-badge:hover {
  border-color: rgba(255, 255, 255, 0.15);
  color: #ffffff;
}

.date-picker-popover {
  position: absolute;
  top: calc(100% + 6px);
  right: 0;
  background: #0A0A0A;
  border: 1px solid #191919;
  border-radius: 12px;
  padding: 20px;
  width: 100%;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.5);
  display: flex;
  flex-direction: column;
  gap: 16px;
  box-sizing: border-box;
}

.date-picker-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.date-picker-field label {
  color: rgba(255, 255, 255, 0.4);
  font-size: 13px;
  font-weight: 500;
  padding-left: 8px;
}

section.convert-page__faqSection.referralfaq {
  max-width: 100%;
  padding: 50px 0px;
}

body .date-picker-input {
  background: #0D0D0D;
  border: 1px solid #222222;
  color: #cbcbcb;
  padding: 10px 18px;
  border-radius: 20px;
  font-size: 13px;
}

/* Make calendar picker icon white and properly aligned */
.date-picker-input::-webkit-calendar-picker-indicator {
  filter: invert(1);
  cursor: pointer;
  opacity: 0.8;
  -webkit-transition: opacity 0.2s ease;
  transition: opacity 0.2s ease;
}

.date-picker-input::-webkit-calendar-picker-indicator:hover {
  opacity: 1;
}

.date-picker-confirm-btn {
  background: #D1AA67;
  color: #000000;
  border: none;
  padding: 8px 16px;
  border-radius: 8px;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s ease;
  width: 100%;
}

.date-picker-confirm-btn:hover {
  opacity: 0.9;
}

.panel-grid-body {
  display: grid;
  grid-template-columns: 1fr 1.2fr;
  gap: 36px;
}

/* Left Column - Gauge Card */
.panel-left-col {
  display: flex;
  flex-direction: column;
}

.base-commission-gauge-card {
  background: #0F0F0F;
  border: 1px solid #191919;
  border-radius: 20px;
  padding: 36px 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  transition: all 0.3s ease;
}

.base-commission-gauge-card:hover {
  border-color: rgba(209, 170, 103, 0.1);
  box-shadow: 0 8px 32px rgba(209, 170, 103, 0.06);
  transform: translateY(-4px);
}

.gauge-card-label {
  font-size: 15px;
  font-weight: 600;
  color: #84888C;
  margin-bottom: 16px;
  text-align: center;
}

.gauge-box {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}

.gauge-svg {
  transform: rotate(0deg);
}

.gauge-inner-val {
  position: absolute;
  bottom: 0px;
  font-size: 42px;
  font-weight: 700;
  color: #ffffff;
  text-align: center;
  width: 100%;
}

/* Right Column - Upgrade Goal Cards */
.panel-right-col {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.upgrade-goal-card {
  background: #0F0F0F;
  border: 1px solid #191919;
  border-radius: 20px;
  height: 100%;
  padding: 20px 24px;
  transition: all 0.3s ease;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
}

.upgrade-goal-card:hover {
  border-color: rgba(209, 170, 103, 0.1);
  box-shadow: 0 8px 32px rgba(209, 170, 103, 0.06);
  transform: translateY(-4px);
}

.upgrade-goal-info {
  display: flex;
  flex-direction: column;
  gap: 1px;
}

.upgrade-title {
  font-size: 17px;
  font-weight: 500;
}

.text-highlight {
  color: #D1AA67;
}

.upgrade-desc {
  font-size: 15px;
  color: rgba(255, 255, 255, 0.5);
}

.upgrade-rate-val {
  font-size: 29px;
  font-weight: 700;
  color: #D1AA67;
  display: flex;
  align-items: center;
  gap: 4px;
  white-space: nowrap;
}

.upgrade-rate-val i {
  font-size: 18px;
}

/* Bottom stats cards in performance wrap */
.panel-bottom-stats-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  margin-top: 10px;
}

.panel-bottom-card {
  background: #0F0F0F;
  border: 1px solid #191919;
  border-radius: 20px;
  padding: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: all 0.3s ease;
}

.panel-bottom-card:hover {
  border-color: rgba(209, 170, 103, 0.2);
  box-shadow: 0 8px 32px rgba(209, 170, 103, 0.08);
  transform: translateY(-4px);
}

.bottom-card-details {
  display: flex;
  align-items: center;
  gap: 14px;
}

.bottom-card-icon-wrap {
  width: 56px;
  height: 56px;
  border-radius: 14px;
  border: 1px solid #222222;
  background: #191919;
  display: flex;
  align-items: center;
  justify-content: center;
}

body.light_theme .bottom-card-icon-wrap {
  border: 1px solid #22222217;
  background: #efefef;
}

.bottom-card-texts {
  display: flex;
  flex-direction: column;
}

.bottom-card-label {
  font-size: 15px;
  color: rgba(255, 255, 255, 0.5);
  font-weight: 500;
}

.bottom-card-val {
  font-size: 30px;
  font-weight: 600;
}

.bottom-card-sparkline {
  display: flex;
  align-items: center;
}

/* Tables Styling */
.history-tab-panel-wrap {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.table-title {
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
  padding-bottom: 16px;
  margin-bottom: 8px;
}

.commission-report-head {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  justify-content: space-between;
  gap: 12px;
}

.commission-report-head .table-title {
  flex: 1 1 220px;
  margin-bottom: 0;
}

.commission-market-filters {
  display: flex;
  gap: 8px;
  padding-bottom: 12px;
}

.commission-market-btn,
.commission-pager-btn {
  border: 1px solid rgba(255, 255, 255, 0.12);
  background: transparent;
  color: rgba(255, 255, 255, 0.8);
  border-radius: 8px;
  padding: 6px 12px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
}

.commission-market-btn.active {
  background: #b3883f;
  border-color: #b3883f;
  color: #fff;
}

.commission-pager {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  font-size: 13px;
}

.commission-pager-btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

body.light_theme .commission-market-btn,
body.light_theme .commission-pager-btn {
  color: #1e2329;
  border-color: rgba(0, 0, 0, 0.12);
}

body.light_theme .commission-market-btn.active {
  color: #fff;
}

body.light_theme .table-title {
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

.panel-table-container {
  overflow-x: auto;
  width: 100%;
}

.overview-data-table {
  width: 100%;
  border-collapse: collapse;
  text-align: left;
}

.overview-data-table th,
.overview-data-table td {
  padding: 16px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
  font-size: 14px;
}

body.light_theme .overview-data-table th,
body.light_theme .overview-data-table td {
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}

.overview-data-table th {
  color: rgba(255, 255, 255, 0.4);
  font-weight: 500;
  text-transform: uppercase;
  font-size: 12px;
  letter-spacing: 0.05em;
}

body.light_theme .overview-data-table th {
  color: rgba(0, 0, 0, 0.7);
}

.overview-data-table td {
  color: #ffffff;
}

.kyc-badge {
  padding: 4px 10px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
}

.kyc-badge.verified {
  background: rgba(16, 185, 129, 0.15);
  color: #10B981;
}

.kyc-badge.pending {
  background: rgba(245, 158, 11, 0.15);
  color: #F59E0B;
}

.kyc-badge.not-verified {
  background: rgba(239, 68, 68, 0.15);
  color: #EF4444;
  white-space: nowrap;
}

/* Empty State Styling */
.history-tab-panel-wrap.empty {
  align-items: flex-start;
}

.panel-empty-state-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 60px 0;
  gap: 16px;
}

.empty-state-img {
  width: 100px;
  height: auto;
  opacity: 0.5;
}

.empty-state-text {
  color: rgba(255, 255, 255, 0.3);
  font-size: 14px;
  font-weight: 500;
}

body.light_theme .empty-state-text {
  color: rgba(0, 0, 0, 0.80);
}

/* Referral Page FAQ List Custom Background and Card Styling */
.referralfaq .convert-page__faqItem {
  background: #ffffff05;
  border-radius: 12px;
  margin-bottom: 16px;
  border: 1px solid rgba(255, 255, 255, 0.03);
  overflow: hidden;
}

.referralfaq .convert-page__faqTitle {
  color: #FFFFFF !important;
}

.referralfaq .convert-page__faqBtn {
  padding: 22px 24px;
  color: #FFFFFF !important;
}

.referralfaq .convert-page__faqChev {
  color: #84888C !important;
}

.referralfaq .convert-page__faqPanel {
  padding: 0 24px 22px;
  color: #84888C !important;
}

@media (max-width: 1440px) {

  .referral-title {
    font-size: 50px;
  }

  .referral-subtitle {
    font-size: 20px;
  }

  .gold-text-accent {
    font-size: 24px;
  }

  .invite-btn {
    padding: 16px 24px;
    font-size: 16px;
  }

  .how-it-works-btn {
    font-size: 16px;
  }

  body .stat-val {
    font-size: 20px;
  }

}


@media (max-width:1367px) {

  .referral-container {
    padding: 0px 0px 30px;
  }

  .referral-overview-section {
    padding: 80px 0px;
  }

}



@media (max-width:1200px) {

  .referral-title {
    font-size: 36px;
  }

  .referral-subtitle {
    font-size: 15px;
  }

  .gold-text-accent {
    font-size: 16px;
  }

  .invite-btn {
    padding: 12px 16px;
    font-size: 14px;
  }

  .how-it-works-btn {
    font-size: 14px;
    padding: 8px 10px;
  }

  .referral-actions {
    gap: 12px;
  }

  .code-value {
    font-size: 22px;
  }

  .referral-overview-section {
    padding: 60px 0px;
  }

  .stats-grid {
    gap: 10px;
    margin-bottom: 18px;
  }

  .ticker-item {
    gap: 12px;
    padding: 0 18px;
  }

  .ticker-pair {
    font-size: 14px;
  }

  .ticker-price {
    font-size: 15px;
  }

  .ticker-change {
    font-size: 14px;
  }

  .ticker-wrap {
    padding: 12px 0;
  }

  .panel-grid-body {
    grid-template-columns: 1fr;
    gap: 24px;
  }

  .panel-inner-title {
    font-size: 20px;
  }

  .date-range-badge {
    font-size: 14px;
  }

  .overview-tab-content-panel {
    border-radius: 18px;
    padding: 28px;
  }

  .bottom-card-val {
    font-size: 20px;
  }

  .bottom-card-label {
    font-size: 13px;
  }

  .upgrade-rate-val {
    font-size: 22px;
  }

  .overview-section-title {
    font-size: 24px;
  }

  .gauge-inner-val {
    font-size: 32px;
  }

  .tab-sidebar-btn {
    gap: 12px;
    padding: 14px 20px;
    border-radius: 10px;
    font-size: 15px;
  }

  .referralfaq .convert-page__faqBtn {
    padding: 16px 24px;
  }


}



@media (max-width: 991px) {



  .referralfaq .convert-page__faqBtn {
    padding: 16px 18px;
  }

  .overview-content-layout {
    grid-template-columns: 180px 1fr;
  }

  .referralfaq .convert-page__faqPanel {
    padding: 0 18px 16px;
  }

  .referral-page-outer {
    padding: 60px 0px;
  }

  .referral-badge {
    font-size: 13px;
    margin-bottom: 12px;
  }

  .referral-title {
    font-size: 32px;
    margin-bottom: 10px;
  }

  .referral-title br {
    display: none;
  }

  .referral-subtitle {
    margin-bottom: 16px;
  }

  .referral-container {
    padding: 0px 0px 40px;
    gap: 10px;
  }

  .referral-overview-section {
    padding: 40px 0px;
  }

  .overview-stats-grid {
    gap: 15px;
    margin-bottom: 32px;
  }

  .overview-section-header {
    margin-bottom: 18px;
  }

  .overview-stat-card {
    border-radius: 12px;
    padding: 14px;
    gap: 12px;
  }

  .stat-card-icon-wrap {
    width: 42px;
    height: 44px;
    border-radius: 8px;
  }

  .stat-card-val {
    font-size: 18px;
  }

  .panel-inner-title {
    font-size: 18px;
  }

  .panel-bottom-card {
    padding: 12px;
  }

  .bottom-card-val {
    font-size: 18px;
  }

  section.convert-page__faqSection.referralfaq {
    padding: 20px 0px;
  }

}


@media (max-width: 767px) {

  .referral-container {
    flex-direction: column;
    text-align: center;
    padding: 0px 0px 10px;
  }

  .overview-stats-grid.referraltbl {
    grid-template-columns: repeat(1, 1fr);
  }

  .referral-actions {
    justify-content: center;
    width: 100%;
  }

  .referral-badge {
    margin: 0 auto;
  }

  .referral-title {
    font-size: 24px;
    width: 100%;
    margin: 10px 0px;
  }

  .invite-btn {
    padding: 8px 16px;
    font-size: 13px;
  }

  .how-it-works-btn {
    font-size: 13px;
  }

  .code-row {
    justify-content: center;
  }

  .referral-hero-right {
    justify-content: center;
  }

  .overview-stats-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .referral-overview-section {
    padding: 30px 0px 0px;
  }

  .time-select-dropdown {
    font-size: 12px;
  }

  .overview-section-title {
    font-size: 22px;
  }


  .overview-content-layout {
    display: flex;
    flex-direction: column;
    width: 100%;
    margin-bottom: 20px;
    min-width: 0;
  }

  .overview-tab-content-panel {
    padding: 18px;
    width: 100%;
  }

  .commission-performance-wrap {
    gap: 18px;
  }

  .stat-card-val {
    font-size: 16px;
  }

  .date-picker-popover {
    padding: 12px;
  }

  .referralfaq .convert-page__faqBtn {
    padding: 12px 15px;
  }

  .date-range-badge {
    font-size: 12px;
  }

  .base-commission-gauge-card {
    padding: 24px 20px;
  }

  .gauge-card-label {
    font-size: 13px;
  }

  .gauge-inner-val {
    font-size: 26px;
  }

  .upgrade-title {
    font-size: 15px;
  }

  .upgrade-desc {
    font-size: 13px;
  }

  .upgrade-rate-val {
    font-size: 18px;
  }

  .panel-bottom-stats-row {
    gap: 15px;
    margin-top: 0px;
  }

  .bottom-card-val {
    font-size: 16px;
  }

  .bottom-card-label {
    font-size: 12px;
  }

}

/* Horizontal tab list wrapper for mobile horizontal scroll with arrows */
.overview-tab-sidebar-wrapper {
  position: relative;
  display: block;
}

.sidebar-scroll-arrow {
  display: none;
  /* Hidden by default on desktop */
}

@media (max-width: 767px) {

  .overview-tab-sidebar-wrapper {
    display: flex;
    align-items: center;
    gap: 8px;
    width: 100%;
    position: relative;
    margin-bottom: 0px;
    min-width: 0;
  }

  .overview-tab-sidebar {
    display: flex !important;
    flex-direction: row !important;
    overflow-x: auto;
    white-space: nowrap;
    scroll-behavior: smooth;
    -ms-overflow-style: none;
    scrollbar-width: none;
    gap: 2px;
    padding: 0px !important;
    border-radius: 0px;
    flex: 1 1;
    min-width: 0;
    align-items: center;
    border: none;
    background: none;
  }

  .overview-tab-sidebar::-webkit-scrollbar {
    display: none;
    /* Safari and Chrome */
  }

  .tab-sidebar-btn {
    flex: 0 0 auto;
    padding: 7px 15px !important;
    font-size: 13px !important;
    border-radius: 7px !important;
    white-space: nowrap;
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .tab-sidebar-btn img,
  .tab-sidebar-btn i {
    width: 18px;
    height: 18px;
    font-size: 18px;
    object-fit: contain;
    opacity: 0.6;
  }

  .upgrade-goal-card {
    border-radius: 16px;
    padding: 18px;
    gap: 12px
  }

  .sidebar-scroll-arrow {
    display: flex;
    align-items: center;
    justify-content: center;
    background: none;
    border: none;
    color: #FFFFFF;
    font-size: 18px;
    padding: 0px;
    width: auto;
    height: initial;
    border-radius: 50%;
    cursor: pointer;
    flex-shrink: 0;
    transition: all 0.2s ease;
    z-index: 2;
  }

  .time-select-menu {
    padding: 2px;
    width: 100%;
  }

  .referral-page-outer {
    padding: 50px 0px 10px;
  }

  .overview-data-table,
  .overview-data-table tbody,
  .overview-data-table tr,
  .overview-data-table td {
    display: block;
    width: 100%;
  }

  .overview-data-table thead {
    display: none;
  }

  .overview-data-table tr {
    margin-bottom: 16px;
    border-radius: 12px;
    padding: 16px;
    border: 1px solid rgba(255, 255, 255, 0.05);
  }

  .overview-data-table td {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 0;
    border-bottom: 1px solid rgba(255, 255, 255, 0.05);
    font-size: 14px;
    text-align: right;
  }

  .overview-data-table td:last-child {
    border-bottom: none;
    padding-bottom: 0;
  }

  .overview-data-table td:first-child {
    padding-top: 0;
  }

  .overview-data-table td::before {
    content: attr(data-label);
    font-weight: 500;
    color: #888;
    font-size: 13px;
    text-align: left;
  }

}

@media (max-width: 580px) {

  .panel-bottom-card {
    gap: 15px;
  }

  .time-select-item {
    font-size: 12px;
  }

  .panel-bottom-stats-row {
    grid-template-columns: 1fr;
  }

  .panel-right-col {
    gap: 18px;
  }

  .base-commission-gauge-card {
    padding: 18px;
    width: 100%;
  }

  .overview-tab-content-panel {
    padding: 10px;
  }

}


@media (max-width:420px) {

  .panel-inner-header {
    align-items: start;
    gap: 12px;
    flex-direction: column;
  }

  .upgrade-goal-card {
    flex-direction: column;
    align-items: start;
  }

}

/* --- How to Invite Section --- */

.how-to-invite-section {
  width: 100%;
  padding: 60px 0 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
}

.how-to-invite-header {
  text-align: center;
  position: relative;
  margin-bottom: 60px;
}

.how-to-invite-title-wrap {
  position: relative;
  z-index: 2;
}

.how-to-invite-title {
  font-size: 40px;
  font-weight: 700;
  color: #ffffff;
  margin-bottom: 8px;
}

.how-to-invite-subtitle {
  font-size: 16px;
  color: #84888C;
}


.invite-steps-container {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  gap: 0;
  width: 100%;
  position: relative;
  margin-bottom: 60px;
  z-index: 2;
  padding-top: 24px;
}

.card-connector {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 1px;
  background: rgba(209, 170, 103, 0.3);
  position: relative;
  margin-top: 86px;
  z-index: 1;
}

.connector-dot {
  width: 6px;
  height: 6px;
  background: #D1AA67;
  border-radius: 50%;
  box-shadow: 0 0 10px 2px rgba(209, 170, 103, 0.6);
}

.invite-step-wrapper {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 1;
  flex: 1 1;
  max-width: 370px;
}

.invite-step-number {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #1b1d23;
  border: 1px solid rgba(209, 170, 103, 0.6);
  color: #D1AA67;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: 600;
  position: absolute;
  top: -20px;
  z-index: 2;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.8);
}

.invite-step-card {
  background: linear-gradient(180deg, #ffffff03 0%, #ffffff0d 100%);
  border: 1px solid rgb(255 255 255 / 2%);
  border-radius: 16px;
  padding: 50px 24px 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  width: 100%;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.5);
  transition: all 0.3s ease;
}

.invite-step-card:hover {
  border-color: rgba(209, 170, 103, 0.2);
  box-shadow: 0 8px 32px rgba(209, 170, 103, 0.08);
  transform: translateY(-5px);
}

.invite-step-icon-wrap {
  width: 85px;
  height: 85px;
  background: transparent;
  border: 1px solid rgb(209 170 103 / 22%);
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 8px 0px 20px;
}

body.light_theme .invite-step-icon-wrap {
  background: #d1aa67;
}

.invite-step-icon-wrap img {
  width: 40px;
  height: auto;
  filter: drop-shadow(0 0 8px rgba(209, 170, 103, 0.5));
}

.invite-step-title {
  font-size: 24px;
  font-weight: 600;
  color: #ffffff;
  line-height: 1.4;
  margin-bottom: 16px;
  min-height: 50px;
}

.invite-step-divider {
  width: 20px;
  height: 2px;
  background: #D1AA67;
  margin-bottom: 16px;
  border-radius: 2px;
}

.invite-step-desc {
  font-size: 18px;
  color: #888888;
  line-height: 1.6;
}



@media (max-width: 1200px) {

  .invite-step-title {
    font-size: 20px;
  }

  .invite-step-desc {
    font-size: 15px;
    margin: 0px;
  }

  .how-to-invite-title {
    font-size: 36px;
  }

}


@media (max-width: 991px) {

  .invite-steps-container {
    flex-direction: column;
    align-items: center;
    gap: 48px;
    padding-top: 0;
  }

  .how-to-invite-section {
    padding: 20px 0 20px;
  }

  .how-to-invite-title {
    font-size: 32px;
  }

  .card-connector {
    display: none;
  }

  .invite-step-wrapper {
    max-width: 500px;
    width: 100%;
  }

}

@media (max-width: 767px) {

  .how-to-invite-title {
    font-size: 24px;
  }

  .invite-step-title {
    font-size: 18px;
    min-height: 100%;
  }

  .invite-step-title br {
    display: none;
  }


  .invite-step-desc {
    font-size: 14px;
  }

  .how-to-invite-subtitle {
    font-size: 14px;
  }

  .invite-step-card {
    padding: 40px 18px 20px;
  }

  .invite-steps-container {
    margin-bottom: 10px;
  }

  .how-to-invite-header {
    margin-bottom: 30px;
  }

  .how-to-invite-section {
    padding: 24px 0 20px;
  }


}

/* Light Theme Overrides */
body.light_theme .referral-page-outer,
body.light_theme .referral-overview-section,
body.light_theme .ticker-wrap,
body.light_theme .how-to-invite-section {
  background-color: #ffffff;
  color: #000000;
}

body.light_theme .referral-title,
body.light_theme .code-value,
body.light_theme .stat-val,
body.light_theme .ticker-price,
body.light_theme .overview-section-title,
body.light_theme .stat-card-val,
body.light_theme .panel-inner-title,
body.light_theme .gauge-inner-val,
body.light_theme .upgrade-title,
body.light_theme .upgrade-rate-val,
body.light_theme .bottom-card-val,
body.light_theme .how-to-invite-title {
  color: #000000;
}

body.light_theme .referral-subtitle,
body.light_theme .card-label,
body.light_theme .stat-label,
body.light_theme .share-label,
body.light_theme .ticker-pair,
body.light_theme .stat-card-label,
body.light_theme .stat-card-sub,
body.light_theme .tab-sidebar-btn,
body.light_theme .date-range-badge,
body.light_theme .date-picker-field label,
body.light_theme .gauge-card-label,
body.light_theme .upgrade-desc,
body.light_theme .upgrade-rate-label,
body.light_theme .bottom-card-label,
body.light_theme .how-to-invite-subtitle,
body.light_theme .how-it-works-btn {
  color: #666666;
}

body.light_theme .referral-card {
  background: linear-gradient(180deg, #fdfdfd 0%, #f7f7f7 15%);
  border-color: #eaeaea;
}

body.light_theme .stat-item,
body.light_theme .share-input-wrap,
body.light_theme .date-picker-input {
  background: #f5f5f5;
  border-color: #eaeaea;
}

body.light_theme .share-input {
  color: #000000;
}

body.light_theme .share-copy-btn,
body.light_theme .date-range-badge i {
  color: #666666;
}

body.light_theme .ticker-wrap,
body.light_theme .overview-stat-card,
body.light_theme .overview-tab-sidebar,
body.light_theme .overview-tab-content-panel,
body.light_theme .date-range-badge,
body.light_theme .base-commission-gauge-card,
body.light_theme .upgrade-goal-card,
body.light_theme .panel-bottom-card {
  background: #ffffff;
  border-color: #eaeaea;
}

body.light_theme .time-select-dropdown,
body.light_theme .time-select-menu,
body.light_theme .date-picker-popover {
  background: #ffffff;
  border-color: #eaeaea;
  color: #000000;
}

body.light_theme .time-select-item {
  color: #666666;
}

body.light_theme .time-select-item:hover {
  background: #f5f5f5;
  color: #000000;
}

body.light_theme .time-select-item.selected {
  color: #000000;
}

body.light_theme .tab-sidebar-btn:hover {
  background: #f5f5f5;
  color: #000000;
}

body.light_theme .tab-sidebar-btn.active {
  background: #D1AA67;
  color: #ffffff;
}

body.light_theme .tab-sidebar-btn:disabled,
body.light_theme .tab-sidebar-btn[aria-disabled="true"] {
  opacity: 0.45;
  color: rgba(0, 0, 0, 0.80);
  background: transparent;
}

body.light_theme .tab-sidebar-btn:disabled:hover,
body.light_theme .tab-sidebar-btn[aria-disabled="true"]:hover {
  background: transparent;
  color: rgba(0, 0, 0, 0.90);
}

body.light_theme .date-picker-input::-webkit-calendar-picker-indicator {
  filter: none;
}

body.light_theme .overview-data-table tr {
  background: #ffffff;
  border-color: #eaeaea;
}

body.light_theme .overview-data-table td {
  border-color: #eaeaea;
  color: #000000;
}

body.light_theme .referral-badge {
  background: #fbf5eb;
  color: #D1AA67;
}

body.light_theme .invite-step-number {
  background: #ffffff;
}

body.light_theme .invite-step-card {
  background: linear-gradient(180deg, #fdfdfd 0%, #f7f7f7 100%);
  border-color: #eaeaea;
}

body.light_theme .invite-step-title {
  color: #000000;
}

body.light_theme .invite-step-desc {
  color: #666666;
}

body.light_theme .referralfaq .convert-page__faqItem {
  background: #ffffff;
  border-color: #eaeaea;
}

body.light_theme .referralfaq .convert-page__faqTitle,
body.light_theme .referralfaq .convert-page__faqBtn {
  color: #000000 !important;
}

body.light_theme .referralfaq .convert-page__faqChev {
  color: #666666 !important;
}

body.light_theme .referralfaq .convert-page__faqPanel,
body.light_theme .referralfaq .convert-page__faqPanel p {
  color: #666666 !important;
}

body.light_theme .invite-step-card {
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.06);
}

body.light_theme .invite-step-card:hover {
  box-shadow: 0 12px 45px rgba(209, 170, 103, 0.15);
}

body.light_theme .invite-step-number {
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);
  border-color: rgba(209, 170, 103, 0.4);
}`, "",{"version":3,"sources":["webpack://./src/ui/Pages/Referral/Referral.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,wEAAwE;AAC1E;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;;AAGA;EACE,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA,gCAAgC;AAChC;EACE,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,qDAAqD;EACrD,wCAAwC;AAC1C;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA,mCAAmC;AACnC;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,wFAAwF;EACxF,2CAA2C;EAC3C,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,2CAA2C;EAC3C,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,wDAAwD;AAC1D;;AAEA;EACE,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;EAClB,yBAAyB;EACzB,kCAAkC;AACpC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,wBAAwB;EACxB,SAAO;EACP,kBAAkB;EAClB,oBAAoB;EACpB,aAAa;EACb,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,+BAA+B;EAC/B,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;AAC3B;;AAEA,mBAAmB;AACnB;EACE,gBAAgB;EAChB,yBAAyB;EACzB,+CAA+C;EAC/C,kDAAkD;EAClD,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,qBAAqB;EACrB,2BAA2B;EAC3B,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,0CAA0C;EAC1C,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,iBAAiB;AACnB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kCAAkC;AACpC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,+BAA+B;AACjC;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,wBAAwB;EACxB,YAAY;EACZ,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;;EAEE,YAAY;EACZ,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;EAEE,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;;EAEE,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA,8BAA8B;AAC9B;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,qCAAqC;EACrC,2CAA2C;EAC3C,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,+BAA+B;EAC/B,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,oCAAoC;AACtC;;AAEA;EACE,uCAAuC;EACvC,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,WAAW;EACX,0CAA0C;EAC1C,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA,yDAAyD;AACzD;EACE,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,qCAA6B;EAA7B,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;AACX;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,sCAAsC;EACtC,gDAAgD;EAChD,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,WAAW;AACb;;AAEA,sCAAsC;AACtC;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,sCAAsC;EACtC,gDAAgD;EAChD,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA,2CAA2C;AAC3C;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,sCAAsC;EACtC,gDAAgD;EAChD,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kDAAkD;EAClD,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,oBAAoB;AACtB;;AAEA;;EAEE,2CAA2C;EAC3C,uBAAuB;EACvB,+BAA+B;EAC/B,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;EACd,iCAAiC;AACnC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,kDAAkD;EAClD,eAAe;AACjB;;AAEA;;EAEE,4CAA4C;AAC9C;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,mBAAmB;AACrB;;AAEA,wBAAwB;AACxB;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,eAAe;EACf,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,8DAA8D;AAC9D;EACE,qBAAqB;EACrB,mBAAmB;EACnB,mBAAmB;EACnB,2CAA2C;EAC3C,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,yBAAyB;AAC3B;;AAEA;;EAEE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;AAEF;;;AAGA;;EAEE;IACE,qBAAqB;EACvB;;EAEA;IACE,iBAAiB;EACnB;;AAEF;;;;AAIA;;EAEE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,SAAS;IACT,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;IACT,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;;AAGF;;;;AAIA;;;;EAIE;IACE,kBAAkB;EACpB;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,qBAAqB;IACrB,SAAS;EACX;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,aAAa;IACb,SAAS;EACX;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;AAEF;;;AAGA;;EAEE;IACE,sBAAsB;IACtB,kBAAkB;IAClB,qBAAqB;EACvB;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,uBAAuB;IACvB,WAAW;EACb;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;;EAGA;IACE,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,aAAa;IACb,WAAW;EACb;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;IACT,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;AAEF;;AAEA,yEAAyE;AACzE;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,iCAAiC;AACnC;;AAEA;;EAEE;IACE,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,wBAAwB;IACxB,8BAA8B;IAC9B,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;IACvB,wBAAwB;IACxB,qBAAqB;IACrB,QAAQ;IACR,uBAAuB;IACvB,kBAAkB;IAClB,SAAS;IACT,YAAY;IACZ,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,cAAc;IACd,4BAA4B;IAC5B,0BAA0B;IAC1B,6BAA6B;IAC7B,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,QAAQ;EACV;;EAEA;;IAEE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,mBAAmB;IACnB,aAAa;IACb;EACF;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,eAAe;IACf,YAAY;IACZ,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,yBAAyB;IACzB,UAAU;EACZ;;EAEA;IACE,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;;;IAIE,cAAc;IACd,WAAW;EACb;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;IACb,2CAA2C;EAC7C;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,kDAAkD;IAClD,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,yBAAyB;IACzB,gBAAgB;IAChB,WAAW;IACX,eAAe;IACf,gBAAgB;EAClB;;AAEF;;AAEA;;EAEE;IACE,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,aAAa;IACb,WAAW;EACb;;EAEA;IACE,aAAa;EACf;;AAEF;;;AAGA;;EAEE;IACE,kBAAkB;IAClB,SAAS;IACT,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;EACpB;;AAEF;;AAEA,kCAAkC;;AAElC;EACE,WAAW;EACX,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;;AAGA;EACE,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,MAAM;EACN,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,WAAW;EACX,oCAAoC;EACpC,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,iDAAiD;AACnD;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,UAAU;EACV,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,0CAA0C;EAC1C,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,uCAAuC;AACzC;;AAEA;EACE,iEAAiE;EACjE,uCAAuC;EACvC,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,yCAAyC;EACzC,yBAAyB;AAC3B;;AAEA;EACE,sCAAsC;EACtC,gDAAgD;EAChD,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,wCAAwC;EACxC,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qDAAqD;AACvD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;;;AAIA;;EAEE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;AAEF;;;AAGA;;EAEE;IACE,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;IACT,cAAc;EAChB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,WAAW;EACb;;AAEF;;AAEA;;EAEE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;;EAGA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,oBAAoB;EACtB;;;AAGF;;AAEA,0BAA0B;AAC1B;;;;EAIE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;;;;;;;;;;;;EAYE,cAAc;AAChB;;AAEA;;;;;;;;;;;;;;;;EAgBE,cAAc;AAChB;;AAEA;EACE,4DAA4D;EAC5D,qBAAqB;AACvB;;AAEA;;;EAGE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;;;;;;;EAQE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;;;EAGE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,aAAa;EACb,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA;;EAEE,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,6DAA6D;EAC7D,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,0CAA0C;EAC1C,sCAAsC;AACxC","sourcesContent":[".referral-page-outer {\n  background-color: #181a20;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 90px 0px 30px;\n  color: #ffffff;\n  overflow: hidden;\n  position: relative;\n  flex-direction: column;\n}\n\n.referral-container {\n  padding: 0px 0px 110px;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 24px;\n  z-index: 2;\n  position: relative;\n}\n\n.referral-hero-left {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n}\n\n.referral-badge {\n  background: #ffffff12;\n  color: #D1AA67;\n  padding: 6px 16px;\n  border-radius: 100px;\n  font-size: 15px;\n  font-weight: 600;\n  margin-bottom: 24px;\n}\n\n.referral-title {\n  font-size: 60px;\n  font-weight: 800;\n  line-height: 1.15;\n  color: #ffffff;\n  margin: 0 0 20px 0;\n  letter-spacing: -0.02em;\n}\n\n.gold-text {\n  color: #D1AA67;\n}\n\n.referral-subtitle {\n  font-size: 23px;\n  color: #84888C;\n  line-height: 1.4;\n  margin-bottom: 36px;\n  max-width: 480px;\n  padding-top: 8px;\n}\n\n.gold-text-accent {\n  color: #D1AA67;\n  font-weight: 700;\n  font-size: 30px;\n}\n\n.referral-actions {\n  display: flex;\n  align-items: center;\n  gap: 24px;\n}\n\n.invite-btn {\n  background: #D1AA67;\n  color: #ffffff;\n  border: none;\n  padding: 18px 36px;\n  border-radius: 100px;\n  font-size: 20px;\n  font-weight: 600;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  transition: transform 0.2s ease, box-shadow 0.2s ease, opacity 0.2s ease;\n}\n\n.invite-btn:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 24px rgba(212, 175, 55, 0.3);\n}\n\n\n.how-it-works-btn {\n  background: transparent;\n  border: none;\n  color: #84888C;\n  font-size: 20px;\n  font-weight: 600;\n  cursor: pointer;\n  padding: 8px 16px;\n  transition: color 0.2s ease;\n}\n\n.how-it-works-btn:hover {\n  color: #ffffff;\n}\n\n/* Center Column - Chest Image */\n.referral-hero-center {\n  max-width: 600px;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.chest-image {\n  width: 100%;\n  height: auto;\n  object-fit: contain;\n  filter: drop-shadow(0 0 30px rgba(34, 197, 94, 0.15));\n  animation: float 4s ease-in-out infinite;\n}\n\n@keyframes float {\n  0% {\n    transform: translateY(0px);\n  }\n\n  50% {\n    transform: translateY(-10px);\n  }\n\n  100% {\n    transform: translateY(0px);\n  }\n}\n\n/* Right Column - User Stats Card */\n.referral-hero-right {\n  width: 100%;\n  display: flex;\n  justify-content: flex-end;\n}\n\n.referral-card {\n  background: linear-gradient(180deg, rgb(255 255 255 / 9%) 0%, rgb(255 255 255 / 5%) 15%);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 32px;\n  padding: 24px 16px;\n  width: 100%;\n  max-width: 480px;\n}\n\n.card-top {\n  display: flex;\n  flex-direction: column;\n  padding-bottom: 0px;\n  margin-bottom: 20px;\n}\n\n.card-label {\n  color: rgba(255, 255, 255, 0.4);\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.code-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.code-value {\n  font-size: 30px;\n  font-weight: 600;\n  color: #ffffff;\n}\n\n.stats-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 16px;\n  margin-bottom: 28px;\n}\n\n.stat-item {\n  background: rgba(255, 255, 255, 0.02);\n  border: 1px solid rgba(255, 255, 255, 0.04);\n  border-radius: 16px;\n  padding: 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  transition: border-color 0.2s ease, background 0.2s ease;\n}\n\n.stat-label {\n  color: rgba(255, 255, 255, 0.4);\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 1.3;\n}\n\nbody .stat-val {\n  font-size: 24px;\n  font-weight: 700;\n  color: #fff;\n}\n\nspan.stat-val.text-gold {\n  color: #D1AA67;\n}\n\n.text-white {\n  color: #ffffff;\n}\n\n.share-link-section {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.share-label {\n  color: rgba(255, 255, 255, 0.4);\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.share-input-wrap {\n  display: flex;\n  align-items: center;\n  background: #ffffff0f;\n  border-radius: 5px;\n  padding: 6px 6px 6px 16px;\n  transition: border-color 0.2s ease;\n}\n\n.share-input-wrap:focus-within {\n  border-color: rgba(212, 175, 55, 0.4);\n}\n\n.share-input {\n  background: transparent;\n  border: none;\n  color: rgba(255 255 255);\n  flex: 1;\n  font-size: 0.85rem;\n  font-family: inherit;\n  outline: none;\n  min-width: 0;\n  padding-right: 8px;\n}\n\n.share-copy-btn {\n  background: none;\n  border: none;\n  color: rgba(255, 255, 255, 0.6);\n  width: 36px;\n  height: 33px;\n  border-radius: 0px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n/* Ticker Styling */\n.ticker-wrap {\n  overflow: hidden;\n  background-color: #000000;\n  border-top: 1px solid rgba(255, 255, 255, 0.08);\n  border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n  padding: 20px 0;\n  width: 100%;\n}\n\n.ticker-track {\n  display: flex;\n  width: max-content;\n  animation: marquee-ticker 130s linear infinite;\n}\n\n.ticker-group {\n  display: flex;\n  align-items: center;\n  flex-shrink: 0;\n}\n\n.ticker-item {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  padding: 0 32px;\n}\n\n.ticker-pair {\n  color: #84888C;\n  font-size: 18px;\n  font-weight: 600;\n}\n\n.ticker-price {\n  color: #ffffff;\n  font-size: 22px;\n  font-weight: 700;\n}\n\n.ticker-change {\n  color: #4ADE80;\n  font-size: 18px;\n  font-weight: 500;\n}\n\n.ticker-chart {\n  height: 18px;\n  width: auto;\n}\n\n.ticker-divider {\n  color: rgba(255, 255, 255, 0.15);\n  font-size: 18px;\n  margin-left: 16px;\n}\n\n@keyframes marquee-ticker {\n  0% {\n    transform: translateX(0);\n  }\n\n  100% {\n    transform: translateX(-50%);\n  }\n}\n\n.referral-overview-section {\n  width: 100%;\n  padding: 110px 0px 0px;\n  display: flex;\n  flex-direction: column;\n  background-color: #181a20;\n  gap: 24px;\n}\n\n.overview-section-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 32px;\n}\n\n.overview-section-title {\n  font-size: 40px;\n  font-weight: 600;\n  color: #ffffff;\n  margin: 0;\n}\n\n.time-select-dropdown-container {\n  position: relative;\n  z-index: 50;\n}\n\n.time-select-dropdown {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  background: #ffffff0f;\n  border: 1px solid #ffffff0d;\n  border-radius: 7px;\n  padding: 7px 18px;\n  color: #84888C;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  min-width: 150px;\n  transition: all 0.2s ease;\n}\n\n.time-select-menu {\n  position: absolute;\n  top: calc(100% + 6px);\n  right: 0;\n  background: #24262b;\n  border: 1px solid #323232;\n  border-radius: 12px;\n  padding: 6px;\n  width: 170px;\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.5);\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.time-select-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 8px 12px;\n  color: rgba(255, 255, 255, 0.6);\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  border-radius: 8px;\n  transition: all 0.2s ease;\n}\n\n.time-select-item:hover {\n  background: rgba(255, 255, 255, 0.03);\n  color: #ffffff;\n}\n\n.time-select-item.selected {\n  color: #ffffff;\n}\n\n.check-icon-circle {\n  width: 16px;\n  height: 16px;\n  border-radius: 50%;\n  background: #D1AA67;\n  color: #000000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 10px;\n  font-weight: bold;\n}\n\n/* Stats Row Grid */\n.overview-stats-grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 24px;\n  margin-bottom: 42px;\n}\n\n.overview-stat-card {\n  width: 100%;\n  background: #ffffff0d;\n  border: 1px solid #ffffff0f;\n  border-radius: 16px;\n  padding: 20px;\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  transition: border-color 0.2s ease;\n}\n\n.overview-stat-card:hover {\n  border-color: rgba(255, 255, 255, 0.1);\n}\n\n.stat-card-icon-wrap {\n  width: 56px;\n  height: 56px;\n  border-radius: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 20px;\n}\n\n.icon-green {\n  background: #091E19;\n  color: #10B981;\n}\n\nbody.light_theme .icon-green {\n  background: #091e1912;\n}\n\nbody.light_theme .icon-orange {\n  background: #2c140c12;\n}\n\nbody.light_theme .icon-blue {\n  background: #10183012;\n}\n\nbody.light_theme .icon-purple {\n  background: #210f2f12;\n}\n\n.icon-orange {\n  background: #2C140C;\n  color: #F97316;\n}\n\n.icon-blue {\n  background: #101830;\n  color: #3B82F6;\n}\n\n.icon-purple {\n  background: #210F2F;\n  color: #A855F7;\n}\n\n.stat-card-details {\n  display: flex;\n  flex-direction: column;\n}\n\n.stat-card-label {\n  font-size: 12px;\n  color: rgba(255, 255, 255, 0.4);\n  font-weight: 500;\n  margin-bottom: 0px;\n}\n\n.stat-card-val {\n  font-size: 20px;\n  font-weight: 700;\n  color: #ffffff;\n}\n\n.stat-card-sub {\n  font-size: 12px;\n  color: rgba(255, 255, 255, 0.3);\n}\n\n/* Sidebar + Content Panel Layout */\n.overview-content-layout {\n  display: grid;\n  grid-template-columns: 280px 1fr;\n  gap: 24px;\n  margin-bottom: 40px;\n}\n\n.overview-tab-sidebar {\n  border-radius: 24px;\n  padding: 10px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  height: -moz-fit-content;\n  height: 100%;\n  background: #ffffff0d;\n  border: 1px solid #ffffff0a;\n}\n\n.tab-sidebar-btn {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  padding: 20px 20px;\n  border-radius: 14px;\n  border: none;\n  background: transparent;\n  color: rgba(255, 255, 255, 0.5);\n  font-size: 18px;\n  font-weight: 500;\n  cursor: pointer;\n  text-align: left;\n  transition: all 0.2s ease;\n}\n\n.tab-sidebar-btn img,\n.tab-sidebar-btn i {\n  opacity: 0.6;\n  font-size: 22px;\n  line-height: 1;\n  flex-shrink: 0;\n}\n\n.tab-sidebar-btn:hover {\n  color: #ffffff;\n  background: rgba(255, 255, 255, 0.02);\n}\n\n.tab-sidebar-btn.active {\n  background: #b3883f;\n  color: #ffffff;\n}\n\n.tab-sidebar-btn.active img,\n.tab-sidebar-btn.active i {\n  opacity: 1;\n}\n\n.tab-sidebar-btn:disabled,\n.tab-sidebar-btn[aria-disabled=\"true\"] {\n  opacity: 0.4;\n  cursor: not-allowed;\n  background: transparent;\n  color: rgba(255, 255, 255, 0.75);\n}\n\n.tab-sidebar-btn:disabled:hover,\n.tab-sidebar-btn[aria-disabled=\"true\"]:hover {\n  background: transparent;\n  color: rgba(255, 255, 255, 0.35);\n}\n\n/* Tab Content Panel Styling */\n.overview-tab-content-panel {\n  background: #ffffff0d;\n  border: 1px solid #ffffff0a;\n  border-radius: 24px;\n  padding: 40px;\n  min-height: 400px;\n}\n\n.commission-performance-wrap {\n  display: flex;\n  flex-direction: column;\n  gap: 36px;\n}\n\n.panel-inner-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding-bottom: 0px;\n}\n\n.panel-inner-title {\n  width: 100%;\n  font-size: 24px;\n  font-weight: 700;\n  margin: 0;\n}\n\n.overview-content-layout .panel-empty-state-wrap .empty-state-img {\n  filter: contrast(0);\n  opacity: 1;\n}\n\n.date-range-container {\n  position: relative;\n  z-index: 40;\n}\n\n.date-range-badge {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  white-space: nowrap;\n  background: rgba(255, 255, 255, 0.02);\n  border: 1px solid rgba(255, 255, 255, 0.06);\n  border-radius: 8px;\n  padding: 6px 12px;\n  font-size: 14px;\n  color: rgba(255, 255, 255, 0.5);\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.date-range-badge i {\n  color: #ffffff;\n  /* Make toggle calendar icon white */\n}\n\n.date-range-badge:hover {\n  border-color: rgba(255, 255, 255, 0.15);\n  color: #ffffff;\n}\n\n.date-picker-popover {\n  position: absolute;\n  top: calc(100% + 6px);\n  right: 0;\n  background: #0A0A0A;\n  border: 1px solid #191919;\n  border-radius: 12px;\n  padding: 20px;\n  width: 100%;\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.5);\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  box-sizing: border-box;\n}\n\n.date-picker-field {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.date-picker-field label {\n  color: rgba(255, 255, 255, 0.4);\n  font-size: 13px;\n  font-weight: 500;\n  padding-left: 8px;\n}\n\nsection.convert-page__faqSection.referralfaq {\n  max-width: 100%;\n  padding: 50px 0px;\n}\n\nbody .date-picker-input {\n  background: #0D0D0D;\n  border: 1px solid #222222;\n  color: #cbcbcb;\n  padding: 10px 18px;\n  border-radius: 20px;\n  font-size: 13px;\n}\n\n/* Make calendar picker icon white and properly aligned */\n.date-picker-input::-webkit-calendar-picker-indicator {\n  filter: invert(1);\n  cursor: pointer;\n  opacity: 0.8;\n  transition: opacity 0.2s ease;\n}\n\n.date-picker-input::-webkit-calendar-picker-indicator:hover {\n  opacity: 1;\n}\n\n.date-picker-confirm-btn {\n  background: #D1AA67;\n  color: #000000;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 8px;\n  font-weight: 600;\n  font-size: 14px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  width: 100%;\n}\n\n.date-picker-confirm-btn:hover {\n  opacity: 0.9;\n}\n\n.panel-grid-body {\n  display: grid;\n  grid-template-columns: 1fr 1.2fr;\n  gap: 36px;\n}\n\n/* Left Column - Gauge Card */\n.panel-left-col {\n  display: flex;\n  flex-direction: column;\n}\n\n.base-commission-gauge-card {\n  background: #0F0F0F;\n  border: 1px solid #191919;\n  border-radius: 20px;\n  padding: 36px 24px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  transition: all 0.3s ease;\n}\n\n.base-commission-gauge-card:hover {\n  border-color: rgba(209, 170, 103, 0.1);\n  box-shadow: 0 8px 32px rgba(209, 170, 103, 0.06);\n  transform: translateY(-4px);\n}\n\n.gauge-card-label {\n  font-size: 15px;\n  font-weight: 600;\n  color: #84888C;\n  margin-bottom: 16px;\n  text-align: center;\n}\n\n.gauge-box {\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.gauge-svg {\n  transform: rotate(0deg);\n}\n\n.gauge-inner-val {\n  position: absolute;\n  bottom: 0px;\n  font-size: 42px;\n  font-weight: 700;\n  color: #ffffff;\n  text-align: center;\n  width: 100%;\n}\n\n/* Right Column - Upgrade Goal Cards */\n.panel-right-col {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n.upgrade-goal-card {\n  background: #0F0F0F;\n  border: 1px solid #191919;\n  border-radius: 20px;\n  height: 100%;\n  padding: 20px 24px;\n  transition: all 0.3s ease;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 16px;\n}\n\n.upgrade-goal-card:hover {\n  border-color: rgba(209, 170, 103, 0.1);\n  box-shadow: 0 8px 32px rgba(209, 170, 103, 0.06);\n  transform: translateY(-4px);\n}\n\n.upgrade-goal-info {\n  display: flex;\n  flex-direction: column;\n  gap: 1px;\n}\n\n.upgrade-title {\n  font-size: 17px;\n  font-weight: 500;\n}\n\n.text-highlight {\n  color: #D1AA67;\n}\n\n.upgrade-desc {\n  font-size: 15px;\n  color: rgba(255, 255, 255, 0.5);\n}\n\n.upgrade-rate-val {\n  font-size: 29px;\n  font-weight: 700;\n  color: #D1AA67;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  white-space: nowrap;\n}\n\n.upgrade-rate-val i {\n  font-size: 18px;\n}\n\n/* Bottom stats cards in performance wrap */\n.panel-bottom-stats-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 20px;\n  margin-top: 10px;\n}\n\n.panel-bottom-card {\n  background: #0F0F0F;\n  border: 1px solid #191919;\n  border-radius: 20px;\n  padding: 20px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  transition: all 0.3s ease;\n}\n\n.panel-bottom-card:hover {\n  border-color: rgba(209, 170, 103, 0.2);\n  box-shadow: 0 8px 32px rgba(209, 170, 103, 0.08);\n  transform: translateY(-4px);\n}\n\n.bottom-card-details {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n}\n\n.bottom-card-icon-wrap {\n  width: 56px;\n  height: 56px;\n  border-radius: 14px;\n  border: 1px solid #222222;\n  background: #191919;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\nbody.light_theme .bottom-card-icon-wrap {\n  border: 1px solid #22222217;\n  background: #efefef;\n}\n\n.bottom-card-texts {\n  display: flex;\n  flex-direction: column;\n}\n\n.bottom-card-label {\n  font-size: 15px;\n  color: rgba(255, 255, 255, 0.5);\n  font-weight: 500;\n}\n\n.bottom-card-val {\n  font-size: 30px;\n  font-weight: 600;\n}\n\n.bottom-card-sparkline {\n  display: flex;\n  align-items: center;\n}\n\n/* Tables Styling */\n.history-tab-panel-wrap {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.table-title {\n  border-bottom: 1px solid rgba(255, 255, 255, 0.06);\n  padding-bottom: 16px;\n  margin-bottom: 8px;\n}\n\n.commission-report-head {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-end;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.commission-report-head .table-title {\n  flex: 1 1 220px;\n  margin-bottom: 0;\n}\n\n.commission-market-filters {\n  display: flex;\n  gap: 8px;\n  padding-bottom: 12px;\n}\n\n.commission-market-btn,\n.commission-pager-btn {\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  background: transparent;\n  color: rgba(255, 255, 255, 0.8);\n  border-radius: 8px;\n  padding: 6px 12px;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.commission-market-btn.active {\n  background: #b3883f;\n  border-color: #b3883f;\n  color: #fff;\n}\n\n.commission-pager {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 12px;\n  font-size: 13px;\n}\n\n.commission-pager-btn:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\nbody.light_theme .commission-market-btn,\nbody.light_theme .commission-pager-btn {\n  color: #1e2329;\n  border-color: rgba(0, 0, 0, 0.12);\n}\n\nbody.light_theme .commission-market-btn.active {\n  color: #fff;\n}\n\nbody.light_theme .table-title {\n  border-bottom: 1px solid rgba(0, 0, 0, 0.06);\n}\n\n.panel-table-container {\n  overflow-x: auto;\n  width: 100%;\n}\n\n.overview-data-table {\n  width: 100%;\n  border-collapse: collapse;\n  text-align: left;\n}\n\n.overview-data-table th,\n.overview-data-table td {\n  padding: 16px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.05);\n  font-size: 14px;\n}\n\nbody.light_theme .overview-data-table th,\nbody.light_theme .overview-data-table td {\n  border-bottom: 1px solid rgba(0, 0, 0, 0.05);\n}\n\n.overview-data-table th {\n  color: rgba(255, 255, 255, 0.4);\n  font-weight: 500;\n  text-transform: uppercase;\n  font-size: 12px;\n  letter-spacing: 0.05em;\n}\n\nbody.light_theme .overview-data-table th {\n  color: rgba(0, 0, 0, 0.7);\n}\n\n.overview-data-table td {\n  color: #ffffff;\n}\n\n.kyc-badge {\n  padding: 4px 10px;\n  border-radius: 6px;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.kyc-badge.verified {\n  background: rgba(16, 185, 129, 0.15);\n  color: #10B981;\n}\n\n.kyc-badge.pending {\n  background: rgba(245, 158, 11, 0.15);\n  color: #F59E0B;\n}\n\n.kyc-badge.not-verified {\n  background: rgba(239, 68, 68, 0.15);\n  color: #EF4444;\n  white-space: nowrap;\n}\n\n/* Empty State Styling */\n.history-tab-panel-wrap.empty {\n  align-items: flex-start;\n}\n\n.panel-empty-state-wrap {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  padding: 60px 0;\n  gap: 16px;\n}\n\n.empty-state-img {\n  width: 100px;\n  height: auto;\n  opacity: 0.5;\n}\n\n.empty-state-text {\n  color: rgba(255, 255, 255, 0.3);\n  font-size: 14px;\n  font-weight: 500;\n}\n\nbody.light_theme .empty-state-text {\n  color: rgba(0, 0, 0, 0.80);\n}\n\n/* Referral Page FAQ List Custom Background and Card Styling */\n.referralfaq .convert-page__faqItem {\n  background: #ffffff05;\n  border-radius: 12px;\n  margin-bottom: 16px;\n  border: 1px solid rgba(255, 255, 255, 0.03);\n  overflow: hidden;\n}\n\n.referralfaq .convert-page__faqTitle {\n  color: #FFFFFF !important;\n}\n\n.referralfaq .convert-page__faqBtn {\n  padding: 22px 24px;\n  color: #FFFFFF !important;\n}\n\n.referralfaq .convert-page__faqChev {\n  color: #84888C !important;\n}\n\n.referralfaq .convert-page__faqPanel {\n  padding: 0 24px 22px;\n  color: #84888C !important;\n}\n\n@media (max-width: 1440px) {\n\n  .referral-title {\n    font-size: 50px;\n  }\n\n  .referral-subtitle {\n    font-size: 20px;\n  }\n\n  .gold-text-accent {\n    font-size: 24px;\n  }\n\n  .invite-btn {\n    padding: 16px 24px;\n    font-size: 16px;\n  }\n\n  .how-it-works-btn {\n    font-size: 16px;\n  }\n\n  body .stat-val {\n    font-size: 20px;\n  }\n\n}\n\n\n@media (max-width:1367px) {\n\n  .referral-container {\n    padding: 0px 0px 30px;\n  }\n\n  .referral-overview-section {\n    padding: 80px 0px;\n  }\n\n}\n\n\n\n@media (max-width:1200px) {\n\n  .referral-title {\n    font-size: 36px;\n  }\n\n  .referral-subtitle {\n    font-size: 15px;\n  }\n\n  .gold-text-accent {\n    font-size: 16px;\n  }\n\n  .invite-btn {\n    padding: 12px 16px;\n    font-size: 14px;\n  }\n\n  .how-it-works-btn {\n    font-size: 14px;\n    padding: 8px 10px;\n  }\n\n  .referral-actions {\n    gap: 12px;\n  }\n\n  .code-value {\n    font-size: 22px;\n  }\n\n  .referral-overview-section {\n    padding: 60px 0px;\n  }\n\n  .stats-grid {\n    gap: 10px;\n    margin-bottom: 18px;\n  }\n\n  .ticker-item {\n    gap: 12px;\n    padding: 0 18px;\n  }\n\n  .ticker-pair {\n    font-size: 14px;\n  }\n\n  .ticker-price {\n    font-size: 15px;\n  }\n\n  .ticker-change {\n    font-size: 14px;\n  }\n\n  .ticker-wrap {\n    padding: 12px 0;\n  }\n\n  .panel-grid-body {\n    grid-template-columns: 1fr;\n    gap: 24px;\n  }\n\n  .panel-inner-title {\n    font-size: 20px;\n  }\n\n  .date-range-badge {\n    font-size: 14px;\n  }\n\n  .overview-tab-content-panel {\n    border-radius: 18px;\n    padding: 28px;\n  }\n\n  .bottom-card-val {\n    font-size: 20px;\n  }\n\n  .bottom-card-label {\n    font-size: 13px;\n  }\n\n  .upgrade-rate-val {\n    font-size: 22px;\n  }\n\n  .overview-section-title {\n    font-size: 24px;\n  }\n\n  .gauge-inner-val {\n    font-size: 32px;\n  }\n\n  .tab-sidebar-btn {\n    gap: 12px;\n    padding: 14px 20px;\n    border-radius: 10px;\n    font-size: 15px;\n  }\n\n  .referralfaq .convert-page__faqBtn {\n    padding: 16px 24px;\n  }\n\n\n}\n\n\n\n@media (max-width: 991px) {\n\n\n\n  .referralfaq .convert-page__faqBtn {\n    padding: 16px 18px;\n  }\n\n  .overview-content-layout {\n    grid-template-columns: 180px 1fr;\n  }\n\n  .referralfaq .convert-page__faqPanel {\n    padding: 0 18px 16px;\n  }\n\n  .referral-page-outer {\n    padding: 60px 0px;\n  }\n\n  .referral-badge {\n    font-size: 13px;\n    margin-bottom: 12px;\n  }\n\n  .referral-title {\n    font-size: 32px;\n    margin-bottom: 10px;\n  }\n\n  .referral-title br {\n    display: none;\n  }\n\n  .referral-subtitle {\n    margin-bottom: 16px;\n  }\n\n  .referral-container {\n    padding: 0px 0px 40px;\n    gap: 10px;\n  }\n\n  .referral-overview-section {\n    padding: 40px 0px;\n  }\n\n  .overview-stats-grid {\n    gap: 15px;\n    margin-bottom: 32px;\n  }\n\n  .overview-section-header {\n    margin-bottom: 18px;\n  }\n\n  .overview-stat-card {\n    border-radius: 12px;\n    padding: 14px;\n    gap: 12px;\n  }\n\n  .stat-card-icon-wrap {\n    width: 42px;\n    height: 44px;\n    border-radius: 8px;\n  }\n\n  .stat-card-val {\n    font-size: 18px;\n  }\n\n  .panel-inner-title {\n    font-size: 18px;\n  }\n\n  .panel-bottom-card {\n    padding: 12px;\n  }\n\n  .bottom-card-val {\n    font-size: 18px;\n  }\n\n  section.convert-page__faqSection.referralfaq {\n    padding: 20px 0px;\n  }\n\n}\n\n\n@media (max-width: 767px) {\n\n  .referral-container {\n    flex-direction: column;\n    text-align: center;\n    padding: 0px 0px 10px;\n  }\n\n  .overview-stats-grid.referraltbl {\n    grid-template-columns: repeat(1, 1fr);\n  }\n\n  .referral-actions {\n    justify-content: center;\n    width: 100%;\n  }\n\n  .referral-badge {\n    margin: 0 auto;\n  }\n\n  .referral-title {\n    font-size: 24px;\n    width: 100%;\n    margin: 10px 0px;\n  }\n\n  .invite-btn {\n    padding: 8px 16px;\n    font-size: 13px;\n  }\n\n  .how-it-works-btn {\n    font-size: 13px;\n  }\n\n  .code-row {\n    justify-content: center;\n  }\n\n  .referral-hero-right {\n    justify-content: center;\n  }\n\n  .overview-stats-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n  .referral-overview-section {\n    padding: 30px 0px 0px;\n  }\n\n  .time-select-dropdown {\n    font-size: 12px;\n  }\n\n  .overview-section-title {\n    font-size: 22px;\n  }\n\n\n  .overview-content-layout {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    margin-bottom: 20px;\n    min-width: 0;\n  }\n\n  .overview-tab-content-panel {\n    padding: 18px;\n    width: 100%;\n  }\n\n  .commission-performance-wrap {\n    gap: 18px;\n  }\n\n  .stat-card-val {\n    font-size: 16px;\n  }\n\n  .date-picker-popover {\n    padding: 12px;\n  }\n\n  .referralfaq .convert-page__faqBtn {\n    padding: 12px 15px;\n  }\n\n  .date-range-badge {\n    font-size: 12px;\n  }\n\n  .base-commission-gauge-card {\n    padding: 24px 20px;\n  }\n\n  .gauge-card-label {\n    font-size: 13px;\n  }\n\n  .gauge-inner-val {\n    font-size: 26px;\n  }\n\n  .upgrade-title {\n    font-size: 15px;\n  }\n\n  .upgrade-desc {\n    font-size: 13px;\n  }\n\n  .upgrade-rate-val {\n    font-size: 18px;\n  }\n\n  .panel-bottom-stats-row {\n    gap: 15px;\n    margin-top: 0px;\n  }\n\n  .bottom-card-val {\n    font-size: 16px;\n  }\n\n  .bottom-card-label {\n    font-size: 12px;\n  }\n\n}\n\n/* Horizontal tab list wrapper for mobile horizontal scroll with arrows */\n.overview-tab-sidebar-wrapper {\n  position: relative;\n  display: block;\n}\n\n.sidebar-scroll-arrow {\n  display: none;\n  /* Hidden by default on desktop */\n}\n\n@media (max-width: 767px) {\n\n  .overview-tab-sidebar-wrapper {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    width: 100%;\n    position: relative;\n    margin-bottom: 0px;\n    min-width: 0;\n  }\n\n  .overview-tab-sidebar {\n    display: flex !important;\n    flex-direction: row !important;\n    overflow-x: auto;\n    white-space: nowrap;\n    scroll-behavior: smooth;\n    -ms-overflow-style: none;\n    scrollbar-width: none;\n    gap: 2px;\n    padding: 0px !important;\n    border-radius: 0px;\n    flex: 1 1;\n    min-width: 0;\n    align-items: center;\n    border: none;\n    background: none;\n  }\n\n  .overview-tab-sidebar::-webkit-scrollbar {\n    display: none;\n    /* Safari and Chrome */\n  }\n\n  .tab-sidebar-btn {\n    flex: 0 0 auto;\n    padding: 7px 15px !important;\n    font-size: 13px !important;\n    border-radius: 7px !important;\n    white-space: nowrap;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n  }\n\n  .tab-sidebar-btn img,\n  .tab-sidebar-btn i {\n    width: 18px;\n    height: 18px;\n    font-size: 18px;\n    object-fit: contain;\n    opacity: 0.6;\n  }\n\n  .upgrade-goal-card {\n    border-radius: 16px;\n    padding: 18px;\n    gap: 12px\n  }\n\n  .sidebar-scroll-arrow {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: none;\n    border: none;\n    color: #FFFFFF;\n    font-size: 18px;\n    padding: 0px;\n    width: auto;\n    height: initial;\n    border-radius: 50%;\n    cursor: pointer;\n    flex-shrink: 0;\n    transition: all 0.2s ease;\n    z-index: 2;\n  }\n\n  .time-select-menu {\n    padding: 2px;\n    width: 100%;\n  }\n\n  .referral-page-outer {\n    padding: 50px 0px 10px;\n  }\n\n  .overview-data-table,\n  .overview-data-table tbody,\n  .overview-data-table tr,\n  .overview-data-table td {\n    display: block;\n    width: 100%;\n  }\n\n  .overview-data-table thead {\n    display: none;\n  }\n\n  .overview-data-table tr {\n    margin-bottom: 16px;\n    border-radius: 12px;\n    padding: 16px;\n    border: 1px solid rgba(255, 255, 255, 0.05);\n  }\n\n  .overview-data-table td {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 10px 0;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.05);\n    font-size: 14px;\n    text-align: right;\n  }\n\n  .overview-data-table td:last-child {\n    border-bottom: none;\n    padding-bottom: 0;\n  }\n\n  .overview-data-table td:first-child {\n    padding-top: 0;\n  }\n\n  .overview-data-table td::before {\n    content: attr(data-label);\n    font-weight: 500;\n    color: #888;\n    font-size: 13px;\n    text-align: left;\n  }\n\n}\n\n@media (max-width: 580px) {\n\n  .panel-bottom-card {\n    gap: 15px;\n  }\n\n  .time-select-item {\n    font-size: 12px;\n  }\n\n  .panel-bottom-stats-row {\n    grid-template-columns: 1fr;\n  }\n\n  .panel-right-col {\n    gap: 18px;\n  }\n\n  .base-commission-gauge-card {\n    padding: 18px;\n    width: 100%;\n  }\n\n  .overview-tab-content-panel {\n    padding: 10px;\n  }\n\n}\n\n\n@media (max-width:420px) {\n\n  .panel-inner-header {\n    align-items: start;\n    gap: 12px;\n    flex-direction: column;\n  }\n\n  .upgrade-goal-card {\n    flex-direction: column;\n    align-items: start;\n  }\n\n}\n\n/* --- How to Invite Section --- */\n\n.how-to-invite-section {\n  width: 100%;\n  padding: 60px 0 20px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  position: relative;\n}\n\n.how-to-invite-header {\n  text-align: center;\n  position: relative;\n  margin-bottom: 60px;\n}\n\n.how-to-invite-title-wrap {\n  position: relative;\n  z-index: 2;\n}\n\n.how-to-invite-title {\n  font-size: 40px;\n  font-weight: 700;\n  color: #ffffff;\n  margin-bottom: 8px;\n}\n\n.how-to-invite-subtitle {\n  font-size: 16px;\n  color: #84888C;\n}\n\n\n.invite-steps-container {\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n  gap: 0;\n  width: 100%;\n  position: relative;\n  margin-bottom: 60px;\n  z-index: 2;\n  padding-top: 24px;\n}\n\n.card-connector {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 64px;\n  height: 1px;\n  background: rgba(209, 170, 103, 0.3);\n  position: relative;\n  margin-top: 86px;\n  z-index: 1;\n}\n\n.connector-dot {\n  width: 6px;\n  height: 6px;\n  background: #D1AA67;\n  border-radius: 50%;\n  box-shadow: 0 0 10px 2px rgba(209, 170, 103, 0.6);\n}\n\n.invite-step-wrapper {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  z-index: 1;\n  flex: 1;\n  max-width: 370px;\n}\n\n.invite-step-number {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  background: #1b1d23;\n  border: 1px solid rgba(209, 170, 103, 0.6);\n  color: #D1AA67;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 16px;\n  font-weight: 600;\n  position: absolute;\n  top: -20px;\n  z-index: 2;\n  box-shadow: 0 0 15px rgba(0, 0, 0, 0.8);\n}\n\n.invite-step-card {\n  background: linear-gradient(180deg, #ffffff03 0%, #ffffff0d 100%);\n  border: 1px solid rgb(255 255 255 / 2%);\n  border-radius: 16px;\n  padding: 50px 24px 40px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  width: 100%;\n  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.5);\n  transition: all 0.3s ease;\n}\n\n.invite-step-card:hover {\n  border-color: rgba(209, 170, 103, 0.2);\n  box-shadow: 0 8px 32px rgba(209, 170, 103, 0.08);\n  transform: translateY(-5px);\n}\n\n.invite-step-icon-wrap {\n  width: 85px;\n  height: 85px;\n  background: transparent;\n  border: 1px solid rgb(209 170 103 / 22%);\n  border-radius: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 8px 0px 20px;\n}\n\nbody.light_theme .invite-step-icon-wrap {\n  background: #d1aa67;\n}\n\n.invite-step-icon-wrap img {\n  width: 40px;\n  height: auto;\n  filter: drop-shadow(0 0 8px rgba(209, 170, 103, 0.5));\n}\n\n.invite-step-title {\n  font-size: 24px;\n  font-weight: 600;\n  color: #ffffff;\n  line-height: 1.4;\n  margin-bottom: 16px;\n  min-height: 50px;\n}\n\n.invite-step-divider {\n  width: 20px;\n  height: 2px;\n  background: #D1AA67;\n  margin-bottom: 16px;\n  border-radius: 2px;\n}\n\n.invite-step-desc {\n  font-size: 18px;\n  color: #888888;\n  line-height: 1.6;\n}\n\n\n\n@media (max-width: 1200px) {\n\n  .invite-step-title {\n    font-size: 20px;\n  }\n\n  .invite-step-desc {\n    font-size: 15px;\n    margin: 0px;\n  }\n\n  .how-to-invite-title {\n    font-size: 36px;\n  }\n\n}\n\n\n@media (max-width: 991px) {\n\n  .invite-steps-container {\n    flex-direction: column;\n    align-items: center;\n    gap: 48px;\n    padding-top: 0;\n  }\n\n  .how-to-invite-section {\n    padding: 20px 0 20px;\n  }\n\n  .how-to-invite-title {\n    font-size: 32px;\n  }\n\n  .card-connector {\n    display: none;\n  }\n\n  .invite-step-wrapper {\n    max-width: 500px;\n    width: 100%;\n  }\n\n}\n\n@media (max-width: 767px) {\n\n  .how-to-invite-title {\n    font-size: 24px;\n  }\n\n  .invite-step-title {\n    font-size: 18px;\n    min-height: 100%;\n  }\n\n  .invite-step-title br {\n    display: none;\n  }\n\n\n  .invite-step-desc {\n    font-size: 14px;\n  }\n\n  .how-to-invite-subtitle {\n    font-size: 14px;\n  }\n\n  .invite-step-card {\n    padding: 40px 18px 20px;\n  }\n\n  .invite-steps-container {\n    margin-bottom: 10px;\n  }\n\n  .how-to-invite-header {\n    margin-bottom: 30px;\n  }\n\n  .how-to-invite-section {\n    padding: 24px 0 20px;\n  }\n\n\n}\n\n/* Light Theme Overrides */\nbody.light_theme .referral-page-outer,\nbody.light_theme .referral-overview-section,\nbody.light_theme .ticker-wrap,\nbody.light_theme .how-to-invite-section {\n  background-color: #ffffff;\n  color: #000000;\n}\n\nbody.light_theme .referral-title,\nbody.light_theme .code-value,\nbody.light_theme .stat-val,\nbody.light_theme .ticker-price,\nbody.light_theme .overview-section-title,\nbody.light_theme .stat-card-val,\nbody.light_theme .panel-inner-title,\nbody.light_theme .gauge-inner-val,\nbody.light_theme .upgrade-title,\nbody.light_theme .upgrade-rate-val,\nbody.light_theme .bottom-card-val,\nbody.light_theme .how-to-invite-title {\n  color: #000000;\n}\n\nbody.light_theme .referral-subtitle,\nbody.light_theme .card-label,\nbody.light_theme .stat-label,\nbody.light_theme .share-label,\nbody.light_theme .ticker-pair,\nbody.light_theme .stat-card-label,\nbody.light_theme .stat-card-sub,\nbody.light_theme .tab-sidebar-btn,\nbody.light_theme .date-range-badge,\nbody.light_theme .date-picker-field label,\nbody.light_theme .gauge-card-label,\nbody.light_theme .upgrade-desc,\nbody.light_theme .upgrade-rate-label,\nbody.light_theme .bottom-card-label,\nbody.light_theme .how-to-invite-subtitle,\nbody.light_theme .how-it-works-btn {\n  color: #666666;\n}\n\nbody.light_theme .referral-card {\n  background: linear-gradient(180deg, #fdfdfd 0%, #f7f7f7 15%);\n  border-color: #eaeaea;\n}\n\nbody.light_theme .stat-item,\nbody.light_theme .share-input-wrap,\nbody.light_theme .date-picker-input {\n  background: #f5f5f5;\n  border-color: #eaeaea;\n}\n\nbody.light_theme .share-input {\n  color: #000000;\n}\n\nbody.light_theme .share-copy-btn,\nbody.light_theme .date-range-badge i {\n  color: #666666;\n}\n\nbody.light_theme .ticker-wrap,\nbody.light_theme .overview-stat-card,\nbody.light_theme .overview-tab-sidebar,\nbody.light_theme .overview-tab-content-panel,\nbody.light_theme .date-range-badge,\nbody.light_theme .base-commission-gauge-card,\nbody.light_theme .upgrade-goal-card,\nbody.light_theme .panel-bottom-card {\n  background: #ffffff;\n  border-color: #eaeaea;\n}\n\nbody.light_theme .time-select-dropdown,\nbody.light_theme .time-select-menu,\nbody.light_theme .date-picker-popover {\n  background: #ffffff;\n  border-color: #eaeaea;\n  color: #000000;\n}\n\nbody.light_theme .time-select-item {\n  color: #666666;\n}\n\nbody.light_theme .time-select-item:hover {\n  background: #f5f5f5;\n  color: #000000;\n}\n\nbody.light_theme .time-select-item.selected {\n  color: #000000;\n}\n\nbody.light_theme .tab-sidebar-btn:hover {\n  background: #f5f5f5;\n  color: #000000;\n}\n\nbody.light_theme .tab-sidebar-btn.active {\n  background: #D1AA67;\n  color: #ffffff;\n}\n\nbody.light_theme .tab-sidebar-btn:disabled,\nbody.light_theme .tab-sidebar-btn[aria-disabled=\"true\"] {\n  opacity: 0.45;\n  color: rgba(0, 0, 0, 0.80);\n  background: transparent;\n}\n\nbody.light_theme .tab-sidebar-btn:disabled:hover,\nbody.light_theme .tab-sidebar-btn[aria-disabled=\"true\"]:hover {\n  background: transparent;\n  color: rgba(0, 0, 0, 0.90);\n}\n\nbody.light_theme .date-picker-input::-webkit-calendar-picker-indicator {\n  filter: none;\n}\n\nbody.light_theme .overview-data-table tr {\n  background: #ffffff;\n  border-color: #eaeaea;\n}\n\nbody.light_theme .overview-data-table td {\n  border-color: #eaeaea;\n  color: #000000;\n}\n\nbody.light_theme .referral-badge {\n  background: #fbf5eb;\n  color: #D1AA67;\n}\n\nbody.light_theme .invite-step-number {\n  background: #ffffff;\n}\n\nbody.light_theme .invite-step-card {\n  background: linear-gradient(180deg, #fdfdfd 0%, #f7f7f7 100%);\n  border-color: #eaeaea;\n}\n\nbody.light_theme .invite-step-title {\n  color: #000000;\n}\n\nbody.light_theme .invite-step-desc {\n  color: #666666;\n}\n\nbody.light_theme .referralfaq .convert-page__faqItem {\n  background: #ffffff;\n  border-color: #eaeaea;\n}\n\nbody.light_theme .referralfaq .convert-page__faqTitle,\nbody.light_theme .referralfaq .convert-page__faqBtn {\n  color: #000000 !important;\n}\n\nbody.light_theme .referralfaq .convert-page__faqChev {\n  color: #666666 !important;\n}\n\nbody.light_theme .referralfaq .convert-page__faqPanel,\nbody.light_theme .referralfaq .convert-page__faqPanel p {\n  color: #666666 !important;\n}\n\nbody.light_theme .invite-step-card {\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.06);\n}\n\nbody.light_theme .invite-step-card:hover {\n  box-shadow: 0 12px 45px rgba(209, 170, 103, 0.15);\n}\n\nbody.light_theme .invite-step-number {\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);\n  border-color: rgba(209, 170, 103, 0.4);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
